import { Injectable } from "@angular/core";
import { Resolve } from "@angular/router";
import { toStream } from "mobx-utils";
import { from, Observable } from "rxjs";
import { map } from "rxjs/operators";

import { DashboardViewService } from "skInsights/dashboard/dashboardView/dashboardView.service";

@Injectable({ providedIn: "root" })
export class DataExplorerTitleResolver implements Resolve<Observable<string>> {

    constructor(
        private dashboardViewService: DashboardViewService,
    ) { }

    /**
     * @note cannot return just observable, otherwise angular waits for emitted
     * value, instead of putting the observable into data
     */
    public async resolve(): Promise<Observable<string>> {
        return from(toStream(() => this.dashboardViewService.dashboard, true)).pipe(
            map(db => db ? `Data: ${db.meta.name}` : ""),
        );
    }
}
